import "./WhyMe.scss";
// import whyMeImg from "../../assets/images/why-me.png";
import { OrbitingCirclesWhyMe } from "../../magicui/OrbitingCircles/OrbitingCirclesWhyMe";
// import OrbitingCircles from "../../OrbitingCircles/";

const WhyMe = () => {

    return <section id="aboutMe-whyMe">
        <div>
            {/* <img src={whyMeImg} alt="WhyMe.png" /> */}
            <OrbitingCirclesWhyMe />
        </div>
        <div>

            {/* <h1>Why Me?</h1> */}
            <p>My expertise spans <strong>React, Flutter, Django, and Unity</strong>, enabling me to tackle various aspects of development, from front-end to back-end and game development. I've successfully completed numerous projects, both individually and as part of a team, delivering <strong>high-quality work</strong> consistently.</p>
            {/* <p>I'm <strong>Naveen</strong>, a passionate <strong>software developer</strong> and <strong>game developer</strong> on an exciting journey of growth. With each project and learning opportunity, I've embraced new technologies and challenges, continually <strong>expanding</strong> my skill set. I thrive on the thrill of learning, eagerly soaking up knowledge every day, no matter how small the detail.
            </p> */}
        </div>
    </section>
}

export default WhyMe;
